export const uploadAudioFileTypes = {
  "audio/flac": [".flac"],
  "audio/wav": [".wav"],
  "audio/mp3": [".mp3"],
  "audio/wave": [".wav"],
  "audio/x-wav": [".wav"],
  "audio/x-pn-wav": [".wav"],
  "audio/vorbis": [".ogg"],
  "audio/m4a": [".m4a"],
  "audio/x-m4a": [".m4a"],
  "audio/aiff": [".aiff", ".aif"],
  "audio/x-aiff": [".aiff", ".aif"],
};

// Shown wherever a file the accept filter let through turns out to be undecodable (a renamed text file, a truncated upload).
export const AUDIO_DECODE_FAILURE_MESSAGE =
  "Could not read audio file. Please try a different file.";
